import React, { useRef } from 'react';
import Draggable from 'react-draggable';

/**
 * Wrapper for react-draggable that works with React 19
 * by providing nodeRef to avoid deprecated findDOMNode
 */
const DraggableCompat = ({ children, ...props }) => {
    const nodeRef = useRef(null);

    return (
        <Draggable nodeRef={nodeRef} {...props}>
            {React.cloneElement(React.Children.only(children), { ref: nodeRef })}
        </Draggable>
    );
};

export default DraggableCompat;
